export const FACILITY_MAP = {
  DARK_MAHATTA: '13',
  DARK_QASMIA: '14',
  MAHATTA: '7',
  QASMIA: '10',
  TEST: '11'
};

export const LBS_CONSTANT = 1000; // in this application this constant is used for kilogram
export const LITER_CONSTANT = 1000;